import * as React from 'react';
import { useSelector } from 'react-redux';

import { Price } from '../../components/Price';
import {
  getPriceForMeterFromDeveloperDisplay,
  getPriceForObjectFromDeveloperDisplay,
} from '../../selectors/newbuilding';
import { PriceRelevanceIconContainer } from '../PriceRelevanceIcon/PriceRelevanceIconContainer';

export function PriceContainer() {
  const pricePerObject = useSelector(getPriceForObjectFromDeveloperDisplay);
  const pricePerMeter = useSelector(getPriceForMeterFromDeveloperDisplay);

  if (!pricePerMeter && !pricePerObject) {
    return null;
  }

  return (
    <Price
      pricePerObject={pricePerObject}
      pricePerMeter={pricePerMeter}
      priceRelevance={<PriceRelevanceIconContainer />}
    />
  );
}
